import React from "react";
import { Link } from "react-router-dom";
import Message from "shared/assets/images/svg/mesage.svg";
import Vision from "shared/assets/images/svg/vision.svg";
import Providing from "shared/assets/images/svg/service_providing.svg";
import Identifying from "shared/assets/images/svg/service_identifying.svg";
import Securing from "shared/assets/images/svg/service_securing.svg";
import Customer from "shared/assets/images/svg/customer_icon.svg";
import Driver from "shared/assets/images/svg/driver_icon.svg";
import Next from "shared/assets/images/svg/next.svg";
import Logo from "shared/assets/images/svg/logo_small.svg";
import Input from "shared/component/inputFields";
import TextArea from "shared/component/textArea";

const Home = () => {
  return (
    <div className="home">
      <div className="container">
        <div className="header-home">
          <div className="row">
            <div className="col-xl-10 mx-auto text-center">
              <h2 className="first">MULTI-DESTINATION CARRIER</h2>
              <h1 className="title">LOREM IPSUM TRANSPORT AGENCY</h1>
              <p className="content">
                Lorem ipsum Transport Agency, we are committed to the continuous pursuit of
                developing and upgrading our services and serving our customers. Lorem ipsum Agency
                is always keen to provide advanced logistical solutions to serve its clients to
                carry out their work with a high level of professionalism..
              </p>
            </div>

            <div className="col-xl-8 mx-auto text-center">
              <div className="buttons">
                <Link to="/signup/customer" className="btn-blue">
                  Sign Up Your Company
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="whoWeAre">
        <div className="container">
          <div className="home-page-header">
            <h1 className="page-title">WHO WE ARE</h1>
            <p className="info">
              The company has grown from local logistical support to what it is today
            </p>
          </div>
          <div className="row ">
            <div className="col-lg-10 col-md-12 mx-auto">
              <div className="row">
                <div className="col-lg-6  col-md-6 ">
                  <div className="box-who">
                    <img src={Vision} alt="VISION" />
                    <h2 className="title">OUR VISION</h2>
                    <p className="content">
                      We at Lorem ipsum Transport Agency are looking forward to becoming the first
                      name in the field of logistics and specialized transport in the Arab world{" "}
                      <br />. . .
                    </p>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6 ">
                  <div className="box-who">
                    <img src={Message} alt="MESSAGE" />
                    <h2 className="title">OUR MESSAGE</h2>
                    <p className="content">
                      Providing professional and high-quality logistic services through the latest
                      transportation technologies and logistical services in the field of transport{" "}
                      <br />. . .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ourServices">
        <div className="container">
          <div className="home-page-header">
            <h1 className="page-title">our services</h1>
            <p className="info">
              We pledge to provide customized solutions to your logistical challenges the way you
              want it
            </p>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="box-services">
                <img src={Providing} alt="PROVIDING" />
                <h1 className="title">PROVIDING</h1>
                <p className="content">
                  providing transportation services to its customers, whether within the city or
                  transporting goods from one city to another <br />.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box-services">
                <img src={Identifying} alt="IDENTIFYING" />
                <h1 className="title">IDENTIFYING</h1>
                <p className="content">
                  Identifying the type of product, its quantity, and the type of transportation
                  required, is it inside or outside the city <br /> .
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mx-auto">
              <div className="box-services">
                <img src={Securing} alt="SECURING" />
                <h1 className="title">SECURING</h1>
                <p className="content">
                  It provides and secures the appropriate means of land transportation for the
                  product in terms of the type of product <br />.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ourValues">
        <div className="container">
          <div className="home-page-header">
            <h1 className="page-title">OUR VALUES</h1>
            <p className="info">
              We are committed to the continuous pursuit of developing and upgrading our services
              and serving our customers
            </p>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="box-value">
                <h1 className="title">
                  COMMITMENT <br /> TO THE CUSTOMER
                </h1>
                <p className="content">
                  We are committed to customer satisfaction by ensuring the quality of the service
                  provided <br /> .
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box-value">
                <h1 className="title">
                  ACCURACY <br /> AND PUNCTUALITY
                </h1>
                <p className="content">
                  We always strive to observe accuracy and punctuality to ensure gaining customers'
                  trust <br /> .
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mx-auto">
              <div className="box-value">
                <h1 className="title">
                  SPEED OF DELIVERY <br /> AND LOW COST
                </h1>
                <p className="content">
                  We strive to complete the required services at the lowest costs while maintaining
                  safety standards <br /> .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="industries">
        <div className="container">
          <div className="home-page-header">
            <h1 className="page-title">KEY INDUSTRIES WE SERVE</h1>
            <p className="info">
              We have been successfully upholding our reputation as a provider of total solutions
              for the logistics needs of several industries.
            </p>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>STEEL</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>CEMENT</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>CONSTRUCTIONS</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>OIL & GAS</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>CONSUMER DURABLES</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>FMCG</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>FURNITURE</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-6">
              <div className="box-industries">
                <p>PETROCHEMICALS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="joinus">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="home-page-header">
                <h1 className="page-title">JOIN US</h1>
                <p className="info">
                  The company has grown from local logistical support to what it is today
                </p>
                <div className="row">
                  <div className="col-md-6 mx-auto">
                    <p></p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-12">
              <div className="business">
                <img src={Customer} alt="customerIcon" />
                <h2>I'M A BUSINESS OWNER</h2>
                <p>
                  Your company needs a modern and developed logistics solutions, just hit the button
                  below and start raising your revenue by using our service.{" "}
                </p>
                <button>Sign Up Your Company</button>
              </div>
            </div>
            <div className="col-lg-4 col-md-12">
              <div className="driver">
                <img src={Driver} alt="driverIcon" />
                <h2>I'M A DRIVER</h2>
                <p>You have the ability to drive and deliver shipments.</p>
                <button>Drive For Us</button>
              </div>
            </div>
          </div>
          <img className="next" src={Next} alt="next" />
          <div className="contactUs">
            <div className="home-page-header">
              <h1 className="page-title">CONTACT US</h1>
              <p className="info">
                Lorem ipsum Transport Agency has deep roots spanning many years in the logistics,
                road freight industry and specialized transportation solutions
              </p>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="contactInfo">
                  <img src={Logo} alt="contactLogo" />
                  <h1>About Us</h1>
                  <p>
                    Lorem ipsum Transport Agency has deep roots spanning many years in the
                    logistics, road freight industry and specialized transportation solutions. The
                    company has grown from local logistical to what it is today, a multi-destination
                    carrier and through land means. We always aspire to become the first name in the
                    field of logistics and handling services in the Arab world .
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="contactForm">
                  <h1>CONTACT US</h1>
                  <Input type="text" label="Your Name:" />
                  <Input type="text" label="Email:" />
                  <Input type="text" label="Phone:" />
                  <Input type="text" label="Subject:" />
                  <TextArea label="share your thoughts with us" />
                  <button className="btn-blue w-100 ">Contact Us</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
